import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { mockClients } from '../../../mocks'
import { Client } from '../../../types/entities'

const ClientsListPage: React.FC = () => {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')

  const filtered = mockClients.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.city.toLowerCase().includes(search.toLowerCase())
  )

  const actionsTemplate = (client: Client) => (
    <Button
      icon='pi pi-eye'
      text
      severity='secondary'
      tooltip='Ver detalhes'
      onClick={() => navigate(`/dashboard/clientes/${client.id}`)}
    />
  )

  const locationTemplate = (client: Client) => `${client.city} – ${client.state}`

  const dateTemplate = (client: Client) =>
    new Date(client.createdAt).toLocaleDateString('pt-BR')

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Clientes</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--text-color-secondary)' }}>
            {mockClients.length} clientes cadastrados
          </p>
        </div>
        <span className='p-input-icon-left'>
          <i className='pi pi-search' />
          <InputText
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder='Buscar cliente...'
          />
        </span>
      </div>

      <DataTable
        value={filtered}
        paginator
        rows={10}
        emptyMessage='Nenhum cliente encontrado.'
        rowHover
        onRowClick={(e) => navigate(`/dashboard/clientes/${(e.data as Client).id}`)}
        style={{ cursor: 'pointer' }}
      >
        <Column field='name' header='Nome' sortable />
        <Column field='email' header='E-mail' sortable />
        <Column field='phone' header='Telefone' />
        <Column header='Localização' body={locationTemplate} sortable sortField='city' />
        <Column header='Desde' body={dateTemplate} sortable sortField='createdAt' />
        <Column header='' body={actionsTemplate} style={{ width: '60px', textAlign: 'center' }} />
      </DataTable>
    </div>
  )
}

export default ClientsListPage
